import React, { useEffect } from 'react';
import { getParameterByName } from '../../components/ControlPanel/ControlPanel';
import BackendService from '../../services/BackendService';
import { useHistory } from 'react-router-dom';

const useValidSession = () => {
  const history = useHistory();

  const sessionId = getParameterByName('sessionUUID') as string;
  const treatmentId = getParameterByName('treatmentUUID') as string;

  useEffect(() => {
    if (!sessionId && !treatmentId) {
      history.push('/invalid-session');
      return;
    }
    if (sessionId && treatmentId) {
      BackendService.checkIfSessionExists(sessionId, treatmentId).then(result => {
        if (!result) {
          history.push('/invalid-session');
        }
      });
    }
  }, [sessionId, treatmentId]);

  return {};
};

export default useValidSession;
